/**
 * Generated by orval v6.9.5 🍺
 * Do not edit manually.
 * Mobility Policy API
 * Mobility policies
 * OpenAPI spec version: 1.0
 */
import type { AuthenticationProviderName } from './component-auth/authenticationProviderName';

export interface SetAuthenticationMappingRequest {
  organisation_id?: string;
  provider?: AuthenticationProviderName;
  sso_token: string;
}
